import React from 'react';
import CustomInput from 'components/common/CustomInput/CustomInput';
import styles from '../VolunteerHoursTargetSettings.module.css';

const TieredConfig = ({ tiers, onChange }) => {
  const handleTierChange = (index, field, value) => {
    const newTiers = [...tiers];
    if (field === 'hours') {
      newTiers[index][field] = value === '' ? '' : parseFloat(value) || 0;
    } else {
      newTiers[index][field] = value === '' ? '' : parseInt(value) || (field === 'maxAthletes' && index === 2 ? null : 0);
    }
    onChange(newTiers);
  };

  // Get example tier for display
  const getExampleTier = () => {
    if (tiers.length > 1) {
      const tier = tiers[1]; // Use tier 2 as example
      return {
        athleteCount: 2,
        hours: tier.hours || 0
      };
    }
    return null;
  };

  const example = getExampleTier();

  return (
    <div className={styles.configSection}>
      <p className={styles.configDescription}>
        Set hours based on number of athletes a member has. Configure three tiers below.
      </p>

      <div className={styles.tieredGrid}>
        <div className={styles.tieredHeader}>
          <span>Tier</span>
          <span>Min Athletes</span>
          <span>Max Athletes</span>
          <span>Required Hours</span>
        </div>

        {tiers.map((tier, index) => (
          <div key={index} className={styles.tieredRow}>
            <div className={styles.tierLabel}>Tier {index + 1}</div>
            <CustomInput
              type="number"
              min="1"
              value={tier.minAthletes ?? ''}
              onChange={(e) => handleTierChange(index, 'minAthletes', e.target.value)}
              placeholder="1"
              style={{ marginBottom: 0 }}
            />
            <div className={styles.maxAthleteInput}>
              {index === 2 ? (
                <span className={styles.infinitySymbol}>∞</span>
              ) : (
                <CustomInput
                  type="number"
                  min={tier.minAthletes || 1}
                  value={tier.maxAthletes ?? ''}
                  onChange={(e) => handleTierChange(index, 'maxAthletes', e.target.value)}
                  placeholder={index + 1}
                  style={{ marginBottom: 0 }}
                />
              )}
            </div>
            <CustomInput
              type="number"
              min="0"
              step="0.5"
              value={tier.hours ?? ''}
              onChange={(e) => handleTierChange(index, 'hours', e.target.value)}
              placeholder="0.0"
              style={{ marginBottom: 0 }}
            />
          </div>
        ))}
      </div>

      {example && (
        <div className={styles.exampleBox}>
          <strong>Example:</strong> A member with {example.athleteCount} athletes falls into 
          Tier 2 and requires <strong>{example.hours} hours</strong>.
        </div>
      )}
    </div>
  );
};

export default TieredConfig;
